<div
  class="nav-node-row"
  [style.padding-left]="'calc(12px + ' + indent + ')'"
  (click)="toggle()"
>
  <span class="nav-node-toggle">
    <i
      *ngIf="hasChildren"
      class="fa"
      [class.fa-chevron-down]="expanded"
      [class.fa-chevron-right]="!expanded"
    ></i>
    <span *ngIf="!hasChildren" style="display:inline-block;width:14px"></span>
  </span>
  <span class="nav-node-name" [title]="node.name">{{ node.name }}</span>
  <span class="nav-node-visits">{{ visits }}</span>
  <span class="nav-node-bar-wrap">
    <span
      class="nav-node-bar-fill"
      [style.width]="barWidth"
      [style.background-color]="barColor"
    ></span>
  </span>
</div>

<div *ngIf="expanded && hasChildren">
  <app-nav-node
    *ngFor="let child of node.children"
    [node]="child"
    [depth]="depth + 1"
    [maxVisits]="maxVisits"
  ></app-nav-node>
</div>
